import { useCallback, useEffect, useState } from 'react';

import {
  getSavedPrinter, isPrinterConfigured, isQzFeatureEnabled, PRINTER_KEYS, PRINTERS_CHANGED_EVENT, QZ_FEATURE_KEY,
} from '../utils/qzTray';

/*
 * Reactive view of the per-station QZ Tray printer config (the source of truth is localStorage,
 * written by qzTray.js#savePrinter). Re-renders when either slot changes — in THIS tab (the custom
 * `qz-printers-changed` event) or in ANOTHER tab (the native `storage` event). The settings card,
 * the sidebar "Set up" badge and the nudge banner all read this, so they stay in sync and the nudges
 * disappear the instant both printers are saved.
 */
const read = () => ({
  zebra: getSavedPrinter('zebra'),
  label: getSavedPrinter('label'),
  configured: isPrinterConfigured(),
  // per-USER on/off for the whole QZ feature (Account page toggle); banner hides when false
  featureEnabled: isQzFeatureEnabled(),
});

export default function usePrinterConfig() {
  const [config, setConfig] = useState(read);

  const refresh = useCallback(() => setConfig(read()), []);

  useEffect(() => {
    const onStorage = (e) => {
      if (!e || e.key === null || e.key === PRINTER_KEYS.zebra || e.key === PRINTER_KEYS.label || e.key === QZ_FEATURE_KEY) {
        refresh();
      }
    };
    window.addEventListener(PRINTERS_CHANGED_EVENT, refresh);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener(PRINTERS_CHANGED_EVENT, refresh);
      window.removeEventListener('storage', onStorage);
    };
  }, [refresh]);

  return config;
}
